import { render, staticRenderFns } from "./ManagerAccessDeniedWarning.vue?vue&type=template&id=d4533a5a"
import script from "./ManagerAccessDeniedWarning.vue?vue&type=script&lang=ts"
export * from "./ManagerAccessDeniedWarning.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4533a5a')) {
      api.createRecord('d4533a5a', component.options)
    } else {
      api.reload('d4533a5a', component.options)
    }
    module.hot.accept("./ManagerAccessDeniedWarning.vue?vue&type=template&id=d4533a5a", function () {
      api.rerender('d4533a5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/alert/ManagerAccessDeniedWarning.vue"
export default component.exports